//用户中心

export default {
    path: '/user',
    component: () => import(/* webpackChunkName: "MAKJUST-PAGE-USER" */ '@/user/viewer.vue'),
    children: [
        {
            path: '',
            redirect: 'dashboard'
        },
        {
            path: 'dashboard',
            component: () => import('@/user/views/dashboard.vue'),
            meta: {
                title: '仪表盘',
                auth: true
            }
        },
        {
            path: 'skin',
            component: () => import('@/user/views/skin.vue'),
            meta: {
                title: '我的皮肤',
                auth: true
            }
        },
        {
            path: 'account',
            component: () => import('@/user/views/account.vue'),
            meta: {
                title: '我的账户',
                auth: true
            }
        },
        {
            path: 'mygames',
            component: () => import('@/user/views/mygames.vue'),
            meta: {
                title: '我的游戏',
                auth: true
            }
        },
        // {
        //     path: 'space/:uid',
        //     component: () => import('@/user/views/space.vue'),
        //     meta: {
        //         title: '个人资料'
        //     }
        // },
    ]
}